<aside class="filter">
  <app-loan
    *ngIf="resultPage"
    (loanOutput)="loanPost()"
    [loanRequestError]="loanRequestError"
    [loanRequestErrorMessage]="loanRequestErrorMessage"
  ></app-loan>
  <app-main-filter
    [filterData]="filterData"
    [filterOptionsData]="filterOptionsData"
    [offersData]="offersData"
    [eternalPage]="eternalPage"
    [resultPage]="resultPage"
    (filterOutput)="filterPost()"
  ></app-main-filter>
</aside>
